import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import DashboardLayout from "../../layout/DashboardLayout";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";
import BackArrow from "../../assets/svg/back-arrow.svg";
import { Box } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CoversureLogo from "../../assets/svg/coversure-logo.svg";
import CalendarImg from "../../assets/svg/calendar.svg";
import UserImg from "../../assets/svg/user.svg";
import AccordionSection from "./accordionSection";
import ChooseBenefits from "./chooseBenefits";
import CardStatusOverlay from "./CardStatusOverlay";
import { useDispatch, useSelector } from "react-redux";
import { addYears, format, subDays } from "date-fns";
import PrimaryButton from "../../components/Button/PrimaryButton";
import PolicyCardScroller from "./PolicyCardScroller";
import { getPolicyDisplayStatus, getPolicyStatus, transformUserDataForRenewal } from "../../utils/policyUtils";
import { handleCustomerDetail, handleSaveUser } from "../../store/reducers/authentication/apiThunk";
import { AppDispatch } from "../../store/store";
import { updateUserData } from "../../store/reducers/authentication";
import { showToast } from "../../components/Toast";

// Mock data moved outside component to prevent recreating on every render
// const MOCK_USER_DATA = [
//   {
//     "address": "jaipur",
//     "dateOfBirth": "1961-04-03T18:30:00.000Z",
//     "email": "mirec74399@buides.com",
//     "firstName": "Giriraj",
//     "gender": "MALE",
//     "lastName": "singh shekhawat",
//     "livLongTransactionID": "PD8VFOVS-4991-7F7A-RH7Q-S7TFSRAPM9K4",
//     "mobileNo": "8442023151",
//     "pinCode": 302013,
//     "policyEndDate": "2026-02-02",
//     "policyStartDate": "2025-04-04",
//     "policyURL": null,
//     "prosureCustomerId": 101
//   },
//   {
//     "address": "jaipur",
//     "dateOfBirth": "2000-04-09T18:30:00.000Z",
//     "email": "mirec74399@buides.com",
//     "firstName": "John",
//     "gender": "MALE",
//     "lastName": "Doe",
//     "livLongTransactionID": "F2DPUO0B-0433-TJQ1-1N4Z-MZWJ5DJT8JPI",
//     "mobileNo": "8442023151",
//     "pinCode": 302013,
//     "policyEndDate": "2026-04-09",
//     "policyStartDate": "2026-04-10",
//     "policyURL": null,
//     "prosureCustomerId": 104
//   },
//   {
//     "address": "jaipur",
//     "dateOfBirth": "2000-04-09T18:30:00.000Z",
//     "email": "mirec74399@buides.com",
//     "firstName": "John",
//     "gender": "MALE",
//     "lastName": "Doe",
//     "livLongTransactionID": "F2DPUO0B-0433-TJQ1-1N4Z-MZWJ5DJT8JPI",
//     "mobileNo": "8442023151",
//     "pinCode": 302013,
//     "policyEndDate": "2025-04-09",
//     "policyStartDate": "2025-04-10",
//     "policyURL": null,
//     "prosureCustomerId": 104
//   },
//   {
//     "address": "jaipur",
//     "dateOfBirth": "2000-04-09T18:30:00.000Z",
//     "email": "mirec74399@buides.com",
//     "firstName": "John",
//     "gender": "MALE",
//     "lastName": "Doe",
//     "livLongTransactionID": "F2DPUO0B-0433-TJQ1-1N4Z-MZWJ5DJT8JPI",
//     "mobileNo": "8442023151",
//     "pinCode": 302013,
//     "policyEndDate": "2026-04-09",
//     "policyStartDate": "2025-04-10",
//     "policyURL": null,
//     "prosureCustomerId": 104
//   },
// {
//   "prosureCustomerId": 269,
//   "firstName": "Naveen",
//   "lastName": "P",
//   "gender": "MALE",
//   "mobileNo": "8105181845",
//   "email": "naveenprabhakar0029@gmail.com",
//   "address": "Soma classic residency,",
//   "pinCode": 560076,
//   "dateOfBirth": "1985-12-02T18:30:00.000+00:00",
//   "policyURL": null,
//   "policyStartDate": null,
//   "policyEndDate": null,
//   "livLongTransactionID": null,
//   "status": "UPCOMING",
//   "renewalStartDate": "2026-01-12"
// },

//  ];

const WellnessServices = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const reduxDetail = useSelector((state: any) => state?.authentication);
  const {
    login: { mobileNo = "" },
  } = reduxDetail;
   const userData = useSelector((state: any) => state?.authentication?.userData);
   //const userData = MOCK_USER_DATA;

  console.log("userData", userData);
  const containerRef = useRef<HTMLDivElement>(null);
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);
  const lastSelectedIdRef = useRef<number | null>(null);
  const [isStart, setIsStart] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [policyList, setPolicyList] = useState<any>([]);
  const [selectData, setSelectData] = useState<any>({});
  const [expanded, setExpanded] = React.useState<string | false>("panel");

  const handleChangeOnAccordionSection =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  // Memoize policyList to prevent recreation
  const processedPolicyList = useMemo(() => {
    if (userData && userData.length > 0) {
      return userData.map((item: any, index: number) => ({
        ...item,
        id: index,
      }));
    }
    return [];
  }, [userData]);

  useEffect(() => {
    if(localStorage.getItem("reloadWellnessPage") === "true"){
      handleUserDetail();
      localStorage.removeItem("reloadWellnessPage");
      return;
    }
    if (processedPolicyList.length > 0 ) {
      setPolicyList(processedPolicyList);
      setSelectData(processedPolicyList[0]);
      lastSelectedIdRef.current = processedPolicyList[0]?.id;
    }
  }, [processedPolicyList]);


  const handleUserDetail = async () => {
    const mob = {
      mobileNo: mobileNo,
    };

    try {
      const resCustomer = await dispatch(handleCustomerDetail(mob)).unwrap();
      if (resCustomer?.status === 1) {
        
        dispatch(updateUserData(resCustomer?.data?.customerDetails));
      }
    } catch (error) {
      showToast("Something went wrong", "error");
      console.error("Error saving user data:", error);
    }
  };

  const checkScrollPosition = () => {
    if (containerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
      setIsStart(scrollLeft === 10 || scrollLeft === 0);
      setIsEnd(scrollLeft + clientWidth >= scrollWidth);
    }
  };

  const scroll = (direction: "left" | "right") => {
    if (containerRef.current) {
      const scrollAmount = 300; // Adjust scroll amount as needed
      containerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  // Intersection Observer for desktop view - auto-select card on scroll
  useEffect(() => {
    if (!containerRef.current || policyList.length === 0) return;

    const options = {
      root: containerRef.current,
      threshold: 0.7,
      rootMargin: "0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = cardRefs.current.findIndex(
            (ref) => ref === entry.target
          );
          if (index !== -1 && policyList[index]) {
            const currentId = policyList[index]?.id;
            // Only update if the selected card is different (using ref to avoid dependency issues)
            if (lastSelectedIdRef.current !== currentId) {
              lastSelectedIdRef.current = currentId;
              setSelectData(policyList[index]);
            }
          }
        }
      });
    }, options);

    // Observe all card elements
    cardRefs.current.forEach((card) => {
      if (card) {
        observer.observe(card);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [policyList]);

  useEffect(() => {
    const container = containerRef.current;

    if (!container) return;

    // Use ResizeObserver to monitor changes
    const resizeObserver = new ResizeObserver(() => {
      checkScrollPosition();
    });

    // Observe container element
    resizeObserver.observe(container);

    // Add scroll event listener
    container.addEventListener("scroll", checkScrollPosition);

    // Clean up
    return () => {
      resizeObserver.disconnect();
      container.removeEventListener("scroll", checkScrollPosition);
    };
  }, []);

  const handleRenewalPolicy = async (item: any) => {
    const transformedData = transformUserDataForRenewal(item);
    console.log("transformedData", transformedData);
    dispatch(handleSaveUser(transformedData)).unwrap().then((res: any) => {
      console.log("res", res);
      if (res?.data?.prosureCustomerId) {
        const dataToSave = {
          prosureCustomerId: res?.data?.prosureCustomerId,
          userData: transformedData,
          paymentData: res?.data?.initiatePayUPaymentResponse,
        }
        localStorage.setItem("dataForPayment", JSON.stringify(dataToSave));
        navigate(ROUTE_PATH.PAYMENT);
      }
    }).catch((err: any) => {
      console.log("err", err);
    });
  };

  // Render the policy status badge on the card
  const renderPolicyStatusBadge = (item: any) => {
    if (!item?.policyStartDate && !item?.policyEndDate && !item?.status && !item?.renewalStartDate) return null;

    const displayStatus = getPolicyDisplayStatus(
      item.policyStartDate,
      item.policyEndDate,
      item.status,
      item.renewalStartDate
    );

    // Don't show anything for normal status (more than 1 month remaining)
    if (displayStatus.type === "normal") return (
      <div className="text-[14px] leading-[20px] text-[#2A3140] flex items-center ">
        <img
          src={CalendarImg}
          alt="CalendarImg"
          style={{ marginRight: "3px", height: "20px", width: "20px"}}
          
        />
        {item?.policyStartDate && item?.policyEndDate
          ? `Valid from ${format(
            new Date(item?.policyStartDate),
            "dd MMM yyyy"
          )} to ${format(
            new Date(item?.policyEndDate),
            "dd MMM yyyy"
          )}`
          : "-"}
      </div>
    );

    // Valid till (less than 1 month remaining)
    if (displayStatus.type === "valid_till") {
      return (
        <div className="flex items-center gap-[4px]">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M14.7502 8.56251C14.6398 9.84505 14.1655 11.0694 13.383 12.0915C12.6004 13.1136 11.5423 13.891 10.3329 14.3321C9.12361 14.7733 7.81345 14.8599 6.55658 14.5817C5.29972 14.3036 4.14844 13.6722 3.2382 12.762C2.32796 11.8517 1.69662 10.7005 1.41846 9.4436C1.14029 8.18673 1.22688 6.87657 1.66803 5.66724C2.10918 4.45792 2.88655 3.39974 3.90866 2.61721C4.93078 1.83468 6.15513 1.36034 7.43767 1.25001C7.63658 1.23343 7.83393 1.29655 7.98631 1.42548C8.13868 1.55441 8.23359 1.7386 8.25017 1.93751C8.26675 2.13642 8.20363 2.33377 8.07469 2.48614C7.94576 2.63852 7.76158 2.73343 7.56267 2.75001C6.56477 2.83559 5.61208 3.20442 4.81671 3.81311C4.02133 4.42179 3.41637 5.245 3.07301 6.18587C2.72965 7.12673 2.66218 8.1461 2.87853 9.12401C3.09489 10.1019 3.58607 10.9977 4.29428 11.7059C5.00249 12.4141 5.89826 12.9053 6.87617 13.1216C7.85408 13.338 8.87345 13.2705 9.81431 12.9272C10.7552 12.5838 11.5784 11.9788 12.1871 11.1835C12.7958 10.3881 13.1646 9.4354 13.2502 8.43751C13.2584 8.33902 13.2859 8.24311 13.3312 8.15525C13.3765 8.0674 13.4386 7.98932 13.514 7.92548C13.5895 7.86164 13.6768 7.81329 13.7709 7.78318C13.865 7.75307 13.9642 7.7418 14.0627 7.75001C14.1612 7.75822 14.2571 7.78574 14.3449 7.83102C14.4328 7.87629 14.5109 7.93842 14.5747 8.01387C14.6385 8.08932 14.6869 8.1766 14.717 8.27074C14.7471 8.36487 14.7584 8.46402 14.7502 8.56251ZM7.25017 4.75001V8.00001C7.25017 8.19892 7.32919 8.38969 7.46984 8.53034C7.61049 8.67099 7.80126 8.75001 8.00017 8.75001H11.2502C11.4491 8.75001 11.6398 8.67099 11.7805 8.53034C11.9212 8.38969 12.0002 8.19892 12.0002 8.00001C12.0002 7.8011 11.9212 7.61033 11.7805 7.46968C11.6398 7.32903 11.4491 7.25001 11.2502 7.25001H8.75017V4.75001C8.75017 4.5511 8.67115 4.36033 8.5305 4.21968C8.38985 4.07903 8.19908 4.00001 8.00017 4.00001C7.80126 4.00001 7.61049 4.07903 7.46984 4.21968C7.32919 4.36033 7.25017 4.5511 7.25017 4.75001ZM13.0002 6.00001C13.198 6.00001 13.3913 5.94136 13.5557 5.83148C13.7202 5.7216 13.8484 5.56542 13.9241 5.38269C13.9997 5.19996 14.0195 4.9989 13.981 4.80492C13.9424 4.61094 13.8471 4.43275 13.7073 4.2929C13.5674 4.15305 13.3892 4.05781 13.1953 4.01922C13.0013 3.98064 12.8002 4.00044 12.6175 4.07613C12.4348 4.15182 12.2786 4.27999 12.1687 4.44444C12.0588 4.60889 12.0002 4.80223 12.0002 5.00001C12.0002 5.26522 12.1055 5.51958 12.2931 5.70711C12.4806 5.89465 12.735 6.00001 13.0002 6.00001ZM11.0002 4.00001C11.198 4.00001 11.3913 3.94136 11.5557 3.83148C11.7202 3.7216 11.8484 3.56542 11.9241 3.38269C11.9997 3.19997 12.0195 2.9989 11.981 2.80492C11.9424 2.61094 11.8471 2.43275 11.7073 2.2929C11.5674 2.15305 11.3892 2.05781 11.1953 2.01922C11.0013 1.98064 10.8002 2.00044 10.6175 2.07613C10.4348 2.15182 10.2786 2.27999 10.1687 2.44444C10.0588 2.60889 10.0002 2.80223 10.0002 3.00001C10.0002 3.26522 10.1055 3.51958 10.2931 3.70711C10.4806 3.89465 10.735 4.00001 11.0002 4.00001Z" fill="#E30202" />
          </svg>
          <span className="text-[14px] leading-[20px] font-[600] text-[#16181D]">
            Valid till {displayStatus.displayDate}
          </span>
        </div>
      );
    }

    // Start from (policy starts in the future)
    if (displayStatus.type === "start_from") {
      return (
        <div className="flex items-center gap-[8px]">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M14.1 3.915L8.6 0.904374C8.4162 0.803214 8.2098 0.750168 8 0.750168C7.7902 0.750168 7.5838 0.803214 7.4 0.904374L1.9 3.915C1.7032 4.02268 1.539 4.18134 1.42464 4.37433C1.31027 4.56732 1.24995 4.78754 1.25 5.01187V10.9881C1.24995 11.2125 1.31027 11.4327 1.42464 11.6257C1.539 11.8187 1.7032 11.9773 1.9 12.085L7.4 15.0956C7.58377 15.1969 7.79018 15.25 8 15.25C8.20982 15.25 8.41623 15.1969 8.6 15.0956L14.1 12.085C14.2968 11.9773 14.461 11.8187 14.5754 11.6257C14.6897 11.4327 14.7501 11.2125 14.75 10.9881V5.01187C14.7501 4.78754 14.6897 4.56732 14.5754 4.37433C14.461 4.18134 14.2968 4.02268 14.1 3.915ZM8 2.28562L12.5 4.75L11.1606 5.48312L6.66062 3.01937L8 2.28562ZM8 7.2125L3.5 4.75L5.0975 3.875L9.5975 6.33812L8 7.2125ZM2.75 6.04937L7.25 8.51187V13.3037L2.75 10.84V6.04937ZM8.75 13.3037V8.51187L10.25 7.69125V9.5C10.25 9.69891 10.329 9.88968 10.4697 10.0303C10.6103 10.171 10.8011 10.25 11 10.25C11.1989 10.25 11.3897 10.171 11.5303 10.0303C11.671 9.88968 11.75 9.69891 11.75 9.5V6.87L13.25 6.04937V10.84L8.75 13.3037Z" fill="#E3B212" />
          </svg>
          <span className="text-[14px] leading-[20px] font-[600] text-[#BA8F03]">
          Starts from {displayStatus.displayDate} to {format(subDays(addYears(new Date(item?.renewalStartDate), 1), 1), "dd MMM yyyy")}
          </span>
        </div>
      );
    }

    // Expired
    if (displayStatus.type === "expired") {
      return (
        <div className="flex items-center gap-[8px]">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M13 4.75H11.25V3.5C11.25 2.63805 10.9076 1.8114 10.2981 1.2019C9.6886 0.59241 8.86195 0.25 8 0.25C7.13805 0.25 6.3114 0.59241 5.7019 1.2019C5.09241 1.8114 4.75 2.63805 4.75 3.5V4.75H3C2.66848 4.75 2.35054 4.8817 2.11612 5.11612C1.8817 5.35054 1.75 5.66848 1.75 6V13C1.75 13.3315 1.8817 13.6495 2.11612 13.8839C2.35054 14.1183 2.66848 14.25 3 14.25H13C13.3315 14.25 13.6495 14.1183 13.8839 13.8839C14.1183 13.6495 14.25 13.3315 14.25 13V6C14.25 5.66848 14.1183 5.35054 13.8839 5.11612C13.6495 4.8817 13.3315 4.75 13 4.75ZM6.25 3.5C6.25 3.03587 6.43437 2.59075 6.76256 2.26256C7.09075 1.93437 7.53587 1.75 8 1.75C8.46413 1.75 8.90925 1.93437 9.23744 2.26256C9.56563 2.59075 9.75 3.03587 9.75 3.5V4.75H6.25V3.5ZM12.75 12.75H3.25V6.25H12.75V12.75ZM9 9.5C9 9.69778 8.94135 9.89112 8.83147 10.0556C8.72159 10.22 8.56541 10.3482 8.38268 10.4239C8.19996 10.4996 7.99889 10.5194 7.80491 10.4808C7.61093 10.4422 7.43275 10.347 7.29289 10.2071C7.15304 10.0673 7.0578 9.88907 7.01921 9.69509C6.98063 9.50111 7.00043 9.30004 7.07612 9.11732C7.15181 8.93459 7.27998 8.77841 7.44443 8.66853C7.60888 8.55865 7.80222 8.5 8 8.5C8.26522 8.5 8.51957 8.60536 8.70711 8.79289C8.89464 8.98043 9 9.23478 9 9.5Z" fill="#E30202" />
          </svg>
          <span className="text-[14px]  leading-[20px] font-[600] text-[#D72727]">
            Expired
          </span>
        </div>
      );
    }

    return null;
  };



  const handleSelectCard = useCallback((item: any) => {
    if (lastSelectedIdRef.current !== item?.id) {
      lastSelectedIdRef.current = item?.id;
      setSelectData(item);
    }
  }, []);

  return (
    <DashboardLayout>
      <div className="p-[16px] lg:p-[38px] xl:p-[50px] relative">

        <div className="sm:hidden flex items-center w-[100%] text-[16px] leading-[20px] font-semibold mt-[16px] mb-[24px]">
          <img
            src={BackArrow}
            alt="BackArrow"
            className="block lg:hidden relative left-[-5%]"
            onClick={() => navigate(ROUTE_PATH.DASHBOARD)}
          />
          <span className="relative top-[-5px] left-[-5%]">
            Wellness Benefits
          </span>
        </div>

        <div>
          <div className="hidden sm:flex items-center justify-between mb-[21px]">
            <div className="text-[20px] leading-[26px] font-bold text-text-color-1 ">
              Current Benefits
            </div>

            {policyList?.length > 1 && (
              // scroll buton for web
              <Box
                className="hidden sm:flex items-center"
                sx={{ justifyContent: "center" }}
              >
                <div
                  onClick={() => !isStart && scroll("left")}
                  style={
                    isStart
                      ? {
                        border: "1px solid #D0D5DD",
                        borderRadius: "50%",
                        padding: "6px",
                        cursor: "pointer",
                      }
                      : {
                        border: "1px solid #1E56FF",
                        borderRadius: "50%",
                        padding: "6px",
                        cursor: "pointer",
                      }
                  }
                >
                  <KeyboardArrowLeftIcon
                    style={
                      isStart
                        ? { color: "#D0D5DD", fontSize: "30px" }
                        : { color: "#1E56FF", fontSize: "30px" }
                    }
                  />
                </div>
                <div
                  onClick={() => !isEnd && scroll("right")}
                  style={
                    isEnd
                      ? {
                        marginLeft: 18,
                        border: "1px solid #D0D5DD",
                        borderRadius: "50%",
                        padding: "6px",
                        cursor: "pointer",
                      }
                      : {
                        marginLeft: 18,
                        border: "1px solid #1E56FF",
                        borderRadius: "50%",
                        padding: "6px",
                        cursor: "pointer",
                      }
                  }
                >
                  <KeyboardArrowRightIcon
                    style={
                      isEnd
                        ? { color: "#D0D5DD", fontSize: "30px" }
                        : { color: "#1E56FF", fontSize: "30px" }
                    }
                  />
                </div>
              </Box>
            )}
          </div>
          {/* Desktop view with scroll container ref */}
          <div className="hidden sm:block">
            <Box
              ref={containerRef}
              sx={{
                display: "flex",
                overflowX: "auto",
                gap: 3,
                scrollSnapType: "x mandatory",
                "&::-webkit-scrollbar": { display: "none" },
              }}
            >
              {policyList.map((item: any, index: number) => (
                <Box
                  sx={{ flex: "0 0 auto", scrollSnapAlign: "start" }}
                  key={index}
                  onClick={() => handleSelectCard(item)}
                >
                  <div
                    ref={(el) => (cardRefs.current[index] = el)}
                    style={
                      selectData?.id === index
                        ? {
                          border: "1px solid blue",
                          backgroundColor: "#EEEEEE",
                        }
                        : {}
                    }
                    className="bg-bg-color-11 lg:bg-white p-[16px] xl:py-[30px] xl:px-[16px] rounded-[25px] w-[296px] lg:w-[350px] xl:w-[400px] 
                    cursor-pointer flex flex-col justify-between items-center"
                  >
                    <img
                      src={CoversureLogo}
                      alt="CoversureLogo"
                      className="lg:w-[400px] h-[18px] lg:h-[30px] p-0 m-[auto]"
                    />
                    <div className="text-[12px] leading-[18px] lg:text-[15px] lg:leading-[22px] font-semibold text-text-color-3 mt-[20px] mb-[10px]">
                      Member name
                    </div>
                    <div className="flex items-center text-[14px] leading-[18px] lg:text-[16px] lg:leading-[22px] font-semibold lg:mb-[21px] mb-[21px]">
                      <img
                        src={UserImg}
                        alt="UserImg"
                        className="w-[20px] lg:w-[28px]"
                        style={{ marginRight: "6px" }}
                      />
                      {item?.firstName + " " + item?.lastName}
                    </div>


                    {/* Policy Status Badge */}
                    {renderPolicyStatusBadge(item)}
                  </div>
                </Box>
              ))}
            </Box>
          </div>

          {/* Mobile view with scroll indicators */}
          <div className="block sm:hidden">
            <PolicyCardScroller
              policyList={policyList}
              selectData={selectData}
              onSelectCard={handleSelectCard}
              isMobile={true}
              handleRenew={handleRenewalPolicy}
            />
          </div>

        </div>
        
        <ChooseBenefits
          selectData={selectData}
          isdisabled={(getPolicyDisplayStatus(selectData?.policyStartDate, selectData?.policyEndDate, selectData?.status, selectData?.renewalStartDate).type === "expired" || getPolicyDisplayStatus(selectData?.policyStartDate, selectData?.policyEndDate, selectData?.status, selectData?.renewalStartDate).type === "start_from")} />
        
        {/* Card Status Overlay - Shows for expired and start_from conditions */}
       
        <div className={`absolute  left-0 right-0 z-[999999] w-[95%] mx-auto md:block hidden ${expanded === "panel1" ? "bottom-[300px]" : "bottom-10"}`}>
          <CardStatusOverlay
            selectData={selectData}
            onRenew={handleRenewalPolicy}
            displayStatus={getPolicyStatus(selectData?.policyEndDate).status}
          />
        </div>
        
        
        <AccordionSection expanded={expanded as string} onChange={handleChangeOnAccordionSection} />
          
        
      </div>
    </DashboardLayout>
  );
};

export default WellnessServices;
